import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-app-my-walls',
  templateUrl: './main-app-my-walls.component.html',
  styleUrls: ['./main-app-my-walls.component.scss']
})
export class MainAppMyWallsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
